// @flow
import React from 'react';
import { omit } from 'lodash';

import { useRouter } from 'Client/router/useRouter';
import { VIRTUAL_PAGE_LOAD } from 'Tracking/constants';
import TrackingComponent from 'Tracking/tracking-component';
import * as trackingStorageApi from 'Tracking/tracking-storage-api';

type Props = {
  trackingKey?: string,
  event?: string,
  track?: () => void,
};
export const TrackingPageLoad = (props: Props) => {
  const { location } = useRouter<{}, { trackingPageLoadAppendSuffix?: string }>();
  const trackingPageLoadAppendSuffix = location.queryParams.trackingPageLoadAppendSuffix;

  const trackingProps = {
    ...(props.trackingKey
      ? /**
         * We need to omit ski data because in case of 2 bookings from the same session,
         * when the first one has ski equipments and second one has none,
         * the second one get wrong ski data from locale storage
         * In case of new ski data exist, it will be added from props anyway
         */
        omit(
          trackingStorageApi.get(props.trackingKey),
          'skiEquipment',
          'skiingEquipment',
          'snowboardingEquipment',
          'hikingEquipment',
        )
      : {}),
    ...{ event: VIRTUAL_PAGE_LOAD },
    ...omit(props, 'children', 'location', 'history', 'match', 'trackingKey'),
  };

  if (trackingPageLoadAppendSuffix) {
    trackingProps.pageName = `${trackingProps.pageName}_${trackingPageLoadAppendSuffix}`;
  }
  React.useEffect(
    () => {
      if (props.event) {
        trackingStorageApi.set(trackingProps);
      }
    },
    [props.event],
  );
  return <TrackingComponent {...trackingProps} track={props.track} />;
};
